import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { CartProduct } from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Autoplay } from 'swiper/modules';
import { useState, useEffect } from "react";
import axios from "axios";
export default function RelatedAccessories() {
    const { t, i18n } = useTranslation();

    const [accessoriesData, setAccessoriesData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/accessories");
                setAccessoriesData(response.data.accessories);
            }
            catch (error) {
                console.error("Error When Fetch Data : ", error);
            }
        }
        fetchData();
    }, [])

    const getLocalizedText = (key) => {
        return i18n.language === 'ar' ? key.A : key.E;
    };


    const showData = accessoriesData.map((el, index) => {
        const priceAfterDiscount = (el.accessories_price * (1 - el.accessories_price_discount / 100)).toFixed(2);
        const inventoryClass = el.accessories_stock_available === "out of Stock" ? "text-red-500" : "text-[#18AB00]";
        const accessoriesName = getLocalizedText({ A: el.accessories_name_A, E: el.accessories_name_E });
        const accessoriesDesc = getLocalizedText({ A: el.accessories_desc_A, E: el.accessories_desc_E });

        return (
            <SwiperSlide key={el.accessories_id}>
                <Link key={index} to={`/accessoriesdetails/${el.accessories_id}`} className=" flex flex-col h-auto bg-[#f6f6f6] w-[250px] overflow-hidden border-[1px] justify-between border-[#d1d1d1] rounded-[4px]">
                    <div className="w-[250px] h-[250px] relative">
                        <div className="w-[250px] h-[250px] border-b-[1px] border-b-[#1485a6]">
                            <img className=" w-full h-full object-contain" src={`https://laravel-api.aj-mart.com/storage/app/public/${el.accessories_main_img}`} alt="" />
                        </div>
                        {/* <div className="w-des w-10 h-10 bg-[#1485a6] rounded-full text-white font-bold flex items-center justify-center absolute top-[10px] right-[10px]">
                            {el.accessories_price_discount * 1}%
                        </div> */}
                    </div>
                    <div className="p-[10px]">
                        <div className="font-15 text-[18px] font-bold text-center  capitalize">{accessoriesName}</div>
                        <p className="font-10 direction-ar-rt text-[13px] text-[#666666] text-center">
                            {t(`${accessoriesDesc.length > 75 ? accessoriesDesc.substring(0, 75) + '...' : accessoriesDesc}`)}
                        </p>
                        <div className="font-14 flex items-center justify-center gap-[5px] text-center">
                            <span className={`font-bold ${inventoryClass}`}>{priceAfterDiscount} <span>{t("JOD")}</span></span>
                            <span className="line-through">{el.accessories_price} <span>{t("JOD")}</span></span>
                        </div>
                        <div className="font-12 text-center font-bold">
                            {t(`${el.accessories_stock_available > 0 ? "In Stock" : "Out of Stock"}`)}
                        </div>
                    </div>
                    <Link
                        to={`/accessoriesdetails/${el.accessories_id}`}
                        className={`bg-[#1485a6] flex p-1.5 items-center justify-center gap-1.5 text-white font-bold rounded-tl-[20px] rounded-tr-[20px] transition-opacity duration-300`}
                    >
                        <CartProduct />
                        {t("Add To Cart")}
                    </Link>
                </Link>
            </SwiperSlide>
        );
    });
    return (
        <section className="pb-[40px]">
            <div className="container">
                <div className="direction-text-ar page-title mb-[20px]">
                    {t("Related")} <span>{t("Accessories")}</span>
                </div>
                <Swiper
                    modules={[Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    style={{ padding: "0 18px", direction: "ltr", height: "500px" }}
                    loop={true}
                    pagination={{
                        clickable: true,
                        renderBullet: (index, className) => {
                            return `<span class="${className} custom-dot"></span>`;
                        },
                    }}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        640: { slidesPerView: 1.5 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 4 },
                    }}
                    className="h-[500px] px-[20px]"
                >
                    {showData}
                </Swiper>
            </div>
        </section>
    )
}